// @flow
import useFeature from './useFeature';

const useMonthlyRollingOnly = () => {
  return useFeature('monthly_bookings_rolling_only');
};

export default useMonthlyRollingOnly;
